var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveRedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_red_eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99984 4.46077C10.5265 4.46077 12.7798 5.88077 13.8798 8.12744C12.7798 10.3741 10.5332 11.7941 7.99984 11.7941C5.4665 11.7941 3.21984 10.3741 2.11984 8.12744C3.21984 5.88077 5.47317 4.46077 7.99984 4.46077ZM7.99984 3.12744C4.6665 3.12744 1.81984 5.20077 0.666504 8.12744C1.81984 11.0541 4.6665 13.1274 7.99984 13.1274C11.3332 13.1274 14.1798 11.0541 15.3332 8.12744C14.1798 5.20077 11.3332 3.12744 7.99984 3.12744ZM7.99984 6.46077C8.91984 6.46077 9.6665 7.20744 9.6665 8.12744C9.6665 9.04744 8.91984 9.79411 7.99984 9.79411C7.07984 9.79411 6.33317 9.04744 6.33317 8.12744C6.33317 7.20744 7.07984 6.46077 7.99984 6.46077ZM7.99984 5.12744C6.3465 5.12744 4.99984 6.47411 4.99984 8.12744C4.99984 9.78078 6.3465 11.1274 7.99984 11.1274C9.65317 11.1274 10.9998 9.78078 10.9998 8.12744C10.9998 6.47411 9.65317 5.12744 7.99984 5.12744Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRedEye);
export default __webpack_public_path__ + "static/media/remove_red_eye.7fc714490b4eec9d43c43ab804a3228a.svg";
export { ForwardRef as ReactComponent };